import { TextField, InputAdornment, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchBarStyle from "./SearchBar.styles";
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from "../../hooks/useTranslation";

function SearchBar({ onSearch , customDetails}) {
  const { t } = useTranslation()
  const theme = useTheme();
  
  // Check for dark theme
  const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';

  const handleSearch = (event) => {
    onSearch(event.target.value);
  };

  return (
    <TextField
      label={t('accountDiscovery.titles.searchInstitutions')}
      variant="outlined"
      fullWidth
      InputLabelProps={{
        sx: {
          ...sizeFontCustom.heading,
          "&.MuiOutlinedInput-notchedOutline": { ...sizeFontCustom.heading },
          flex: "inline",
          borderRadius: "40px",
          color: isDark ? "#fff" : ""
        },
      }}
      onChange={handleSearch}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "grey" }} height="1.5rem" width="1.5rem" />
          </InputAdornment>
        ),
      }}
      sx={{ 
        ...SearchBarStyle.textField, 
        background: isDark ? '#161616' : theme.palette.secondary.main,
        border: isDark ? "1px solid #fff" : "",
        color: isDark ? '#FFFFFF' : '#000000'
      }}
    />
  );
}

export default SearchBar;
